import React, { Component } from "react";
import { Spin, Modal } from "antd";
import {
  history,
  showErrorNotification,
  showSuccessNotification
} from "../../../helpers";
import AdminsView from "./AdminsView";
import AddEditModal from "./AddEditModal";
import {
  deleteClinicAdmin,
  getClinicAdmins
} from "../../../services/clinicService";

export default class AdminsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminsList: [],
      showModal: false,
      selectedRecord: null,
      totalRecords: 0,
      pageNo: 1,
      perPage: 10,
      clinicId: null,
      isProcessing: false
    };
  }

  componentDidMount() {
    const { clinicId } = this.props;
    this.setState({ clinicId }, () => {
      this.fetchClinicAdmins();
    });
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  fetchClinicAdmins = () => {
    const { pageNo, perPage, clinicId } = this.state;
    this.setState({ isProcessing: true });
    getClinicAdmins(clinicId, pageNo, perPage)
      .then(response => {
        if (response.data.success) {
          this.setState({
            adminsList: response.data.data.clinic_admin,
            totalRecords: response.data.data.total_records
          });
        } else {
          this.setState({
            adminsList: [],
            totalRecords: 0
          });
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };
  handleEdit = record => {
    this.setState({ selectedRecord: record }, () => {
      this.toggleModal();
    });
  };
  handleDelete = record => {
    const { clinicId } = this.state;
    Modal.confirm({
      title: `Delete confirmation`,
      content: (
        <div>{`Are you sure you want to delete this admin
          `}</div>
      ),
      onOk: () => {
        deleteClinicAdmin(clinicId, record.id).then(response => {
          if (response.data.success) {
            showSuccessNotification("Admin deleted successfully!");
            this.fetchClinicAdmins();
          } else {
            showErrorNotification(response.data.errors[0].title);
          }
        });
      }
    });
  };

  onPageChange = page => {
    this.setState({ pageNo: page }, () => {
      this.fetchClinicAdmins();
    });
  };

  render() {
    const {
      adminsList,
      modalType,
      showModal,
      perPage,
      pageNo,
      clinicId,
      isProcessing,
      selectedRecord
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <AdminsView
          adminsList={adminsList}
          toggleModal={this.toggleModal}
          handleEdit={this.handleEdit}
          handleDelete={this.handleDelete}
          onPageChange={this.onPageChange}
          pageNo={pageNo}
          perPage={perPage}
        />
        <AddEditModal
          showModal={showModal}
          toggleModal={this.toggleModal}
          clinicId={clinicId}
          fetchClinicAdmins={this.fetchClinicAdmins}
          selectedRecord={selectedRecord}
        />
      </Spin>
    );
  }
}
